import { render, staticRenderFns } from "./Contact2Demo.vue?vue&type=template&id=f710d788&"
import script from "./Contact2Demo.vue?vue&type=script&lang=js&"
export * from "./Contact2Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports